import * as jQuery from "jquery";
import { cookies, options } from "brownies";
import Swiper from "swiper/bundle";
import Plyr from "plyr";
import autosize from "autosize";
import SalleForm from "./components/salle-form";
import NlForm from "./components/nl-form";
import ContactForm from "./components/contact-form";
import SpecFilters from "./components/spec-filters";
(function ($) {
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Variables
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var w = window,
    d = document,
    $window = $(w),
    $html = $("html"),
    $body = $("body"),
    $header = $("#header"),
    $main = $("#main"),
    $footer = $("#footer"),
    $nav = $("#nav"),
    $nav_i = $nav.find("li"),
    $menuTrigger = $("#menuTrigger"),
    windowH,
    windowW,
    scrollT,
    sauvScroll = 0,
    $adminBar = $("#wpadminbar"),
    has_adminBar = $body.hasClass("admin-bar"),
    adminBar_h = 0,
    bandeau_h = 0,
    header_h = 0,
    serveur_test = d.location.hostname == "localhost",
    is_requeting = false;

  cookies[options] = {
    expires: 604800, //604800 = 7 * 24 * 3600, une semaine
    domain: url.cookie_domain, // The domain for the cookie
    path: url.cookie_path, // The path for the cookie
  };

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Dimensions
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function update_dimensions() {
    windowH = $window.height();
    windowW = $window.width();
    update_adminbar();
    update_bandeau_h();
    update_header_h();
    update_scroll();
    main_min_height();
  }
  function update_scroll() {
    scrollT = $window.scrollTop();
  }

  function update_filters_pos() {
    const $filters = $("#spec-filters");
    if ($filters.length) {
      const total_h = bandeau_h + header_h + adminBar_h;
      $filters.css("top", total_h + "px");
    }
  }

  function update_adminbar() {
    $adminBar =
      !$adminBar.length && has_adminBar ? $("#wpadminbar") : $adminBar;
    adminBar_h = $adminBar.length ? $adminBar.height() : has_adminBar ? 32 : 0;
    update_filters_pos();
  }
  function update_bandeau_h() {
    const $bandeau = $(".header_bandeau");
    bandeau_h =
      $bandeau.length && $bandeau.is(":visible") ? $bandeau.outerHeight() : 0;
    update_filters_pos();
  }
  function update_header_h() {
    const $header_inner = $(".header_inner");
    header_h =
      $header_inner.length && $header_inner.is(":visible")
        ? $header_inner.outerHeight()
        : 0;
    update_filters_pos();
  }

  function main_min_height() {
    $main.css(
      "min-height",
      windowH - $footer.outerHeight() - $nav.outerHeight()
    );
  }
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Scroll jusqu'a un element
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function scrollToEl($el) {
    $("html, body").animate(
      {
        scrollTop: $el
          ? $el.offset().top -
            $nav.outerHeight() -
            parseInt($html.css("margin-top"))
          : 0,
      },
      300
    );
  }

  var $directElToScroll = $body.find(".js-scroll-to-me").first();
  if ($directElToScroll.length) scrollToEl($directElToScroll);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Ajax
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function init_ajax($cont) {
    var $links = ($cont && $cont.length ? $cont : $body).find(
      'a[href^="' + url.home + '"]:not([href^="' + url.content + '"])'
    );
    $links.on("click", ajax_trigger);
  }
  init_ajax();

  function ajax_all_scripts($cont) {
    $cont = $cont && $cont.length ? $cont : $body;
    init_ajax($cont);
    sliders_init($cont);
    salle_form_init($cont);
    contact_form_init($cont);
    form_init($cont);
    nl_form_init();
    // covers_init($cont);
    accs_init($cont);
    spec_filtres_init();
    scroll_to_next_specs();
    // fs_init($cont);
    // audio_init_links($cont);
    // object_fill_polyfill($cont);
    // audio_update_classes_active($cont);
    // Désactivation covoiturage 20/09/23
    // covoiturage_init($cont);
  }

  function ajax_trigger(event) {
    var $this = $(this);
    if (
      ($this.hasClass("nav_link") && $this.get(0).nextElementSibling) ||
      $this.hasClass("js-acc-trigger") ||
      $this.data("fs") ||
      $this.hasClass("no-ajax") ||
      // Middle click, cmd click, and ctrl click
      event.which > 1 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    )
      return;
    event.preventDefault();
    if (!is_requeting) {
      closeSubMenu();
      $html.removeClass("has-menuMobilOpen");
      $nav_i.removeClass("is-active");
      $this.parents(".nav_i, .nav_si").addClass("is-active");
      var url = $this.attr("href");
      ajax_load_page(url);
    }
  }

  function ajax_load_page(url, pop, params) {
    var args = {
      url: url,
      type: "GET",
      data: { is_ajax: "1" },
      beforeSend: function () {
        $body.addClass("ajax-loading");
        //$main.css('height', $main.outerHeight()+'px');
        //$main.empty();
        // scrollToEl(false);
        $("html, body").animate(
          {
            scrollTop: headerFix
              ? 0
              : $nav.offset().top - parseInt($html.css("margin-top")),
          },
          300
        );
        is_requeting = true;
      },
    };
    if (typeof params === "object") {
      args = $.extend(true, args, params);
    }
    $.ajax(args)
      .done(function (data) {
        data = data.replace("<html></html>", "");
        const regex = /<!--(.*?)-->/gim;
        data = data.replace(regex, "");
        data = JSON.parse(data);
        if (data.body_class) {
          // Ne pas supprimer la classe admin-bar
          $body.removeClass(function (_idx, className) {
            var classes = className.split(" ");
            if (classes.includes("admin-bar")) {
              var idxOfAdminBar = classes.indexOf("admin-bar");
              delete classes[idxOfAdminBar];
            }
            return classes.join(" ");
          });
          $body.addClass(data.body_class);
        }
        if (data.content) {
          $main.html(data.content);
          ajax_all_scripts($main);
        }
        if (data.id) {
          $("#wpadminbar")
            .find("#wp-admin-bar-edit")
            .find('a[href*="&post="],a[href*="?post="]')
            .each(function (index, el) {
              $(el).attr(
                "href",
                $(el)
                  .attr("href")
                  .replace(/(&|\?)(post=)([0-9]+)/, "$1$2" + data.id)
              );
              if (data.edit_text) $(el).text(data.edit_text);
            });
        }
        // Force le rendu des boutons de covoiturage
        if (typeof parseAndTransform !== "undefined") {
          parseAndTransform();
        }
        if (!pop) {
          update_history({ url: data.url || url, title: data.title });
        }
      })
      .fail(function (data) {
        if (data.responseJSON && data.responseJSON.content) {
          $main.html(data.responseJSON.content);
          ajax_all_scripts($main);
        }
        if (!pop) {
          update_history({
            url: data.responseJSON.url || url,
            title: data.responseJSON.title,
          });
        }
      })
      .always(function (data) {
        $body.removeClass("ajax-loading");
        //$main.removeAttr('style');
        is_requeting = false;
      });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //History
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var currentPageUrl = "",
    // currentPageUrlRelative = window.location.pathname,
    currentPageUrlRelative = "",
    currentState = {},
    auto_pop_history = true;

  // Non-webkit browsers don't fire an initial popstate event
  if ("state" in window.history) {
    auto_pop_history = false;
  }

  set_history_vars();

  window.history.replaceState(currentState, "", currentPageUrl);

  w.addEventListener("popstate", function (e) {
    if (!e.state || currentPageUrl == e.state.url) return;

    set_history_vars(e.state);

    ajax_load_page(e.state.url, true);

    if (currentState.title) {
      document.title = currentState.title;
    }
    track_stats();
  });

  function set_history_vars(state) {
    currentPageUrl = window.location.href;
    currentPageUrlRelative = currentPageUrl.replace(/^(?:\/\/|[^\/]+)*\//, "/");
    if (state) {
      currentState = state;
    } else if (window.history.state) {
      currentState = window.history.state;
    } else {
      currentState = {
        title: document.title,
        url: currentPageUrl,
      };
    }
  }

  function update_history(state) {
    if (state.title) {
      document.title = state.title;
    }
    window.history.pushState(state, "", state.url);
    set_history_vars();
    track_stats();
  }

  function track_stats() {
    if (typeof _paq === "undefined") {
      return;
    }
    _paq.push(["setDocumentTitle", document.title]);
    _paq.push(["setCustomUrl", currentPageUrlRelative]);

    if ($main.find(".is-search").length > 0) {
      _paq.push([
        "trackSiteSearch",
        $main.find("input[name=s]:first").val(),
        false,
        $main.find(".found-posts:first").text(),
      ]);
    } else {
      if ($main.find(".is-404").length > 0) {
        _paq.push([
          "setDocumentTitle",
          "404/URL = " +
            encodeURIComponent(
              document.location.pathname + document.location.search
            ) +
            "/From = " +
            encodeURIComponent(document.referrer),
        ]);
      }
      _paq.push(["trackPageView"]);
    }
    _paq.push(["enableLinkTracking"]);
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var $nav_links = $nav.find(".nav_link");
  var $nav_items = $nav.find(".nav_i");
  $nav_links.each(function (idx, el) {
    $(el).on("click", trigger_nav_link);
  });

  $(".search-button").on("click", function () {
    $(".nav_i.nav_i-search").find(".nav_link").trigger("click");
  });

  function trigger_nav_link(event) {
    var $this = $(this);
    var $link_item = $this.closest(".nav_i");
    var $sub_menu = $link_item.find(".nav_sub");
    if ($sub_menu.length) {
      event.preventDefault();
    }
    if ($link_item.hasClass("is-open")) {
      $link_item.removeClass("is-open");
      if ($sub_menu.length) {
        $html.removeClass("has-subnavOpen");
      }
    } else {
      $nav_items.removeClass("is-open");
      $link_item.addClass("is-open");
      if ($sub_menu.length) {
        $html.addClass("has-subnavOpen");
      }
    }
  }

  function closeSubMenu() {
    $html.removeClass("has-subnavOpen");
    $nav_items.removeClass("is-open");
    if ($html.hasClass("has-menuMobilOpen")) {
      $html.removeClass("has-menuMobilOpen");
    }
  }

  $nav.find(".search_form").on("submit", function (event) {
    var $form = $(this);
    event.preventDefault();
    $form.find(":focus").blur();
    closeSubMenu();
    ajax_load_page($form.attr("action") || window.location.href, false, {
      type: $form.attr("method") || "get",
      data: $form.serialize() + "&is_ajax=1",
    });
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Menu mobile
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var menuMobilTrigger = $("#menuTrigger");
  if (menuMobilTrigger.length) {
    menuMobilTrigger.on("click", trigger_menu_mobil);
  }

  function trigger_menu_mobil(e) {
    e.preventDefault();
    if ($html.hasClass("has-menuMobilOpen")) {
      $html.removeClass("has-menuMobilOpen");
      window.scrollTo(0, sauvScroll);
    } else {
      sauvScroll = scrollT;
      $html.addClass("has-menuMobilOpen");
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sliders
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const slider_set_temoignages = (idx, el) => {
    const $el = $(el);
    $el.addClass(`temoignages-slider-${idx}`);
    const $parent = $(el).closest(
      ".bloc-temoignages, .footer_temoignages_wrapper"
    );
    const $prev = $parent.find(".slider-arrow-left");
    const $next = $parent.find(".slider-arrow-right");
    $prev.addClass(`slider-arrow-${idx}`);
    $next.addClass(`slider-arrow-${idx}`);
    const swiper = new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        prevEl: `.slider-arrow-left.slider-arrow-${idx}`,
        nextEl: `.slider-arrow-right.slider-arrow-${idx}`,
      },
      breakpoints: {
        // when window width is >= 768
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  };

  const slider_set_page = (idx, el) => {
    const $el = $(el);
    $el.addClass(`block-slider-${idx}`);
    const $prev = $el.find(".slider-arrow-left");
    const $next = $el.find(".slider-arrow-right");
    $prev.addClass(`slider-arrow-${idx}`);
    $next.addClass(`slider-arrow-${idx}`);
    const swiper = new Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 15,
      navigation: {
        prevEl: `.slider-arrow-left.slider-arrow-${idx}`,
        nextEl: `.slider-arrow-right.slider-arrow-${idx}`,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        // when window width is >= 640px
        768: {
          spaceBetween: 20,
        },
      },
    });
    plyr_page_init(el);
  };

  function sliders_init($cont) {
    var $sliders_temoignages = $body.find(
      ".temoignages-inner:not(.slider-enabled), .footer_temoignages_inner:not(.slider-enabled)"
    );
    var $sliders_page = ($cont && $cont.length ? $cont : $main).find(
      ".block-slider:not(.slider-enabled)"
    );
    var $sliders_solo = ($cont && $cont.length ? $cont : $main).find(
      ".slider-single-img"
    );
    if ($sliders_temoignages.length) {
      $sliders_temoignages.each(function (idx, el) {
        slider_set_temoignages(idx, el);
      });
    }
    if ($sliders_page.length) {
      $sliders_page.each(function (idx, el) {
        slider_set_page(idx, el);
      });
    }
    if ($sliders_solo.length) {
      $sliders_solo.each(function (idx, el) {
        plyr_page_init(el);
      });
    }
  }
  sliders_init();

  function sliderReadMore(){
    $('.temoignages-inner .testimony-text').each(function(k, item){
      let height = $(item).height();
      if(height > 140){
        $(item).addClass('read-more');
      }
    });
  }
  sliderReadMore();
  
  function sliderReadMoreExtend() {
    $('.read-more').on('click', function(){
      $(this).toggleClass('extended');
    });
  }
  sliderReadMoreExtend();

  function plyr_page_init(el) {
    const $el = $(el);
    $el.find(".plyr-player:not(.is-init)").each(function (idx, el) {
      const player = new Plyr(el);
      player.on("ready", function (event) {
        $(el).find(".plyr-player").addClass("is-init");
      });
    });
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Init accordéons
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  const toggle_acc = ($acc, $cont) => {
    const $acc_head = $acc.find(".acc_head");
    const $acc_content = $acc.find(".acc_content");
    const id = $acc_head.attr("id");
    const is_open = $acc.hasClass("is-active");
    $acc.toggleClass("is-active");
    $acc_head.attr("aria-selected", !is_open);
    $acc_content.attr("aria-expanded", !is_open);
    $acc_content[is_open ? "slideUp" : "slideDown"]({
      duration: 300,
    });
    $acc_content.attr("aria-hidden", is_open);
    // Si l’accordéon était fermé, ça veut dire qu'on ferme les autres.
    if (!is_open) {
      const $accs = $cont.find(".acc");
      $accs.not($acc).each((idx, el) => {
        const $el = $(el);
        close_acc($el);
      });
    }
  };

  const close_acc = ($acc) => {
    const $acc_head = $acc.find(".acc_head");
    const $acc_content = $acc.find(".acc_content");
    $acc.removeClass("is-active");
    $acc_head.attr("aria-selected", false);
    $acc_content.attr("aria-expanded", false);
    $acc_content.slideUp({
      duration: 300,
      queue: false,
    });
  };

  const onClickAcc = (e, $cont) => {
    const $acc_head = $(e.currentTarget);
    const $acc = $acc_head.closest(".acc");
    toggle_acc($acc, $cont);
  };
  const accs_init = ($cont) => {
    const $accs = $cont.find(".acc");
    $accs.each((idx, el) => {
      const $el = $(el);
      const $acc_head = $el.find(".acc_head");
      const $acc_content = $el.find(".acc_content");

      $el.attr("id", `acc-${idx}`);
      $acc_head.attr("id", `tab-${idx}`);
      $acc_head.attr("aria-controls", `pan-${idx}`);
      $acc_content.attr("id", `pan-${idx}`);
      $acc_content.attr("aria-labelledby", `tab-${idx}`);
      $el.find(".acc_head").on("click", (e) => {
        onClickAcc(e, $cont);
      });
    });
  };
  accs_init($body);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Init covoiturage
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // const covoiturage_init = ($cont) => {
  //   $cont = $cont && $cont.length ? $cont : $main;
  //   if (!$cont.find(".covoituragesimple").length) return;

  //   if (!$("#covoiturage-style").length) {
  //     var link = document.createElement("link");
  //     link.id = "covoiturage-style";
  //     link.rel = "stylesheet";
  //     link.type = "text/css";
  //     link.href = "https://widget.covoiturage-simple.com/button.css";
  //     document.getElementsByTagName("HEAD")[0].appendChild(link);
  //     $.getScript("https://widget.covoiturage-simple.com/button.js");
  //   }
  // };
  // covoiturage_init($body);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Sticky header
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var headerFix = $html.hasClass("has-stickyHeader");
  function maj_header() {
    if (!headerFix) {
      setTimeout(function () {
        var offsetHeader = $header
          .find(".header_inner")
          .get(0)
          .getBoundingClientRect().top;
        if (offsetHeader < 0) {
          $html.addClass("has-stickyHeader");
          headerFix = true;
          window.scrollTo(0, Math.abs(offsetHeader));
          cookie.set("hide-splash-screen", 1, { path: "/" });
        }
      }, 1000);
    }
  }

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Labels form
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  function form_init($cont) {
    if (!$cont || !$cont.length) {
      $cont = $main;
    }
    $cont
      .find(".form_field")
      .find("input,textarea,select")
      .each(function (index, input) {
        var $input = $(input);
        var isSelect = $input.is("select");
        field_blur(input);
        if (isSelect) {
          $(input).on("change", function (event) {
            field_blur(this);
          });
        } else {
          $(input)
            .on("focus", function (event) {
              field_focus(this);
            })
            .on("blur", function (event) {
              field_blur(this);
            });
        }
      });

    function field_blur(input) {
      var $input = $(input);
      var $parent = $input.closest(".form_field");
      var isValid = input.validity.valid;
      var len = input.value.length;
      var isSelect = $input.is("select");

      if (!isSelect && !isValid && !len) $input.val(""); //Fix number no value if invalid
      if (len) $parent.addClass("is-full");
      else $parent.removeClass("is-full");
      $parent.removeClass("is-focus");
    }

    function field_focus(input) {
      var $input = $(input);
      var $parent = $input.closest(".form_field");
      $parent.addClass("is-focus");
    }

    $cont
      .find(".form")
      .find("input,textarea,select")
      .on("focus", function (event) {
        $(this).closest(".is-error").removeClass("is-error");
      });

    $cont.find(".form").on("submit", function (event) {
      var $form = $(this);
      event.preventDefault();
      ajax_load_page(
        $form.attr("action") || window.location.href,
        false,
        {
          type: $form.attr("method") || "get",
          data: $form.serialize() + "&is_ajax=1",
        },
        true
      );
    });
  }
  form_init($main);

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Textarea autosize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  autosize($main.find(".form textarea"));

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Select stylisé focus/bur
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body
    .find(".select select")
    .on("focus", function (event) {
      $(this).parent().addClass("is-open");
    })
    .on("blur", function (event) {
      $(this).parent().removeClass("is-open");
    });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Accordéon texte
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body.on("click", ".txtEncart", function () {
    var $this = $(this),
      $content = $this.find(".txtEncart_text");
    if ($this.hasClass("txtEncart--opened")) {
      TweenLite.to($content, 0.25, { height: 0 });
      $this.removeClass("txtEncart--opened");
    } else {
      $(".txtEncart--opened").each(function (index) {
        $contenu = $(this).find(".txtEncart_text");
        TweenLite.to($contenu, 0.25, { height: 0 });
        $(this).removeClass("txtEncart--opened");
      });
      TweenLite.set($content, { height: "auto" });
      TweenLite.from($content, 0.25, { height: 0 });
      $this.addClass("txtEncart--opened");
    }
  });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Gestion du cookie d’affichage de la préhome
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body.on("click", ".prehome-link", function () {
    cookies.has_seen_prehome = true;
  });
  if (document.referrer) {
    const referrer_url = new URL(document.referrer);
    const theatre_url = new URL(strings.theatre_url);
    const congres_url = new URL(strings.congres_url);
    if (
      referrer_url.host === theatre_url ||
      referrer_url.host === congres_url
    ) {
      cookies.has_seen_prehome = true;
    }
  }
  if (document.location) {
    const url = new URL(document.location);
    if (url.searchParams.get("prehome") !== null) {
      cookies.has_seen_prehome = true;
    }
  }
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // Bandeau dernière minute
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $body.on("click", ".bandeau_close", function () {
    update_dimensions();
    const $bandeau = $header.find(".header_bandeau");
    if ($bandeau.hasClass("bandeau-theatre")) {
      cookies.bandeau_theatre_closed = true;
    }
    if ($bandeau.hasClass("bandeau-congres")) {
      cookies.bandeau_congres_closed = true;
    }
    $header.removeClass("is-bandeau");
  });

  const init_bandeau = () => {
    const $bandeau = $header.find(".header_bandeau");
    if ($bandeau.length) {
      if (
        $bandeau.hasClass("bandeau-theatre") &&
        !cookies.bandeau_theatre_closed
      ) {
        $header.addClass("is-bandeau");
      }
      if (
        $bandeau.hasClass("bandeau-congres") &&
        !cookies.bandeau_congres_closed
      ) {
        $header.addClass("is-bandeau");
      }
    }
  };

  init_bandeau();

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Keys event
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // $html.on( "keydown", function( event ) {
  //   // event.which (27: echap, etc.)
  //   if(event.which == 27) {
  //     //...
  //   }
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On resize
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  $window
    .on("resize", function (event) {
      update_dimensions();
      maj_header();
      update_filters_pos();
    })
    .trigger("resize");

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //Tarteaucitron
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  // tarteaucitron.init({
  //   privacyUrl: "" /* Privacy policy url */,

  //   hashtag: "#tarteaucitron" /* Open the panel with this hashtag */,
  //   cookieName: "tarteaucitron" /* Cookie name */,

  //   orientation: "bottom" /* Banner position (top - bottom) */,

  //   showAlertSmall: false /* Show the small banner on bottom right */,
  //   cookieslist: false /* Show the cookie list */,

  //   showIcon: true /* Show cookie icon to manage cookies */,
  //   iconPosition:
  //     "BottomRight" /* BottomRight, BottomLeft, TopRight and TopLeft */,

  //   adblocker: false /* Show a Warning if an adblocker is detected */,
  //   closePopup: false /* Show a close X on the banner */,
  //   DenyAllCta: true /* Show the deny all button */,
  //   AcceptAllCta: true /* Show the accept all button when highPrivacy on */,
  //   highPrivacy: true /* HIGHLY RECOMMANDED Disable auto consent */,

  //   handleBrowserDNTRequest: false /* If Do Not Track == 1, disallow all */,

  //   removeCredit: true /* Remove credit link */,
  //   moreInfoLink: true /* Show more info link */,

  //   useExternalCss: true /* If false, the tarteaucitron.css file will be loaded */,
  //   useExternalJs: false /* If false, the tarteaucitron.js file will be loaded */,

  //   //"cookieDomain": ".my-multisite-domaine.fr", /* Shared cookie for multisite */

  //   readmoreLink: "" /* Change the default readmore link */,

  //   mandatory: true /* Show a message about mandatory cookies */,
  // });

  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //On scroll
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  //■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
  var ticking = false;
  $window
    .on("scroll", function (event) {
      update_scroll();
      requestTick();
    })
    .trigger("scroll");

  function requestTick() {
    if (!ticking) {
      ticking = true;
      w.requestAnimationFrame(trigger_scroll);
    }
  }

  function trigger_scroll() {
    ticking = false;
    maj_header();
  }

  const getRender = async () => {
    return import("@wordpress/element").then(({ render }) => {
      return render;
    });
  };

  const salle_form_init = async ($cont) => {
    var $salle_form = ($cont && $cont.length ? $cont : $main).find(
      "#salle-form-container"
    );
    if ($salle_form.length && !$salle_form.hasClass("is-init")) {
      const render = await getRender();
      render(SalleForm(), document.getElementById("salle-form-container"));
      $salle_form.addClass("is-init");
    }
  };
  salle_form_init();

  const contact_form_init = async ($cont) => {
    var $contact_form = ($cont && $cont.length ? $cont : $main).find(
      "#contact-form-container"
    );
    if ($contact_form.length && !$contact_form.hasClass("is-init")) {
      const render = await getRender();
      render(ContactForm(), document.getElementById("contact-form-container"));
      $contact_form.addClass("is-init");
    }
  };
  contact_form_init();

  const nl_form_init = async () => {
    const $nl_form = $("#nl-form");
    if ($nl_form.length && !$nl_form.hasClass("is-init")) {
      const render = await getRender();
      render(NlForm(), $nl_form[0]);
      $nl_form.addClass("is-init");
    }
  };
  nl_form_init();

  const spec_filtres_init = async ($cont) => {
    var $spec_filters = ($cont && $cont.length ? $cont : $main).find(
      "#spec-filters"
    );
    if ($spec_filters.length) {
      if (!$spec_filters.hasClass("is-init")) {
        const render = await getRender();
        render(SpecFilters(), document.getElementById("spec-filters"));
        update_dimensions();
        update_filters_pos();
        $spec_filters.addClass("is-init");
      }
    }
  };
  spec_filtres_init();

  const scroll_to_next_specs = () => {
    if ($("body").hasClass("page-template-template-archives-spectacle")) {
      const some_passed =
        $(".page-content .grid-3").find(".spec-card.has-passed").length > 0;
      const $first = $(".page-content .grid-3")
        .find(".spec-card:not(.has-passed)")
        .first();
      if ($first.length && some_passed) {
        scrollToEl($first);
      }
    }
  };
  scroll_to_next_specs();
})(jQuery);
